<template>
  <FormItemWrapper>
    <FormItemLabel slot="label">{{ $t('formItemLabelDistributor') }}</FormItemLabel>
    <Tooltip
      v-if="$t('formItemTooltipDistributor')"
      slot="tooltip"
      :content="$t('formItemTooltipDistributor')"
    />
    <el-select v-model="distributor">
      <el-option
        v-for="(item, index) in distributors"
        :key="`item-${index}`"
        :label="item.legal_name"
        :value="item.id"/>
    </el-select>
  </FormItemWrapper>
</template>

<script>
import Vue from 'vue';
import { Select, Option } from 'element-ui';
import FormItemWrapper from '@/components/formItem/Wrapper.vue';
import FormItemLabel from '@/components/formItem/Label.vue';
import Tooltip from '@/components/Tooltip.vue';

Vue.use(Select);
Vue.use(Option);

export default {
  name: 'FilterDistributor',
  components: {
    FormItemWrapper,
    FormItemLabel,
    Tooltip,
  },
  computed: {
    distributors() {
      return this.$store.state.filter.distributors;
    },
    distributor: {
      get() {
        return this.$store.state.filter.activeFilters.distributor;
      },
      set(value) {
        this.$store.commit('filter/SET_DISTRIBUTOR', value);
      },
    },
  },
};
</script>
